import React from 'react'

const AiSparkleIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M21.5935 10.6138L17.835 10.5655L15.6647 13.6343L14.9372 11.2939L14.5491 10.0452L13.3004 9.65707L10.96 8.92952L14.0287 6.75922L13.9805 3.00074L16.9929 5.24858L20.5527 4.04153L19.3457 7.60134L21.5935 10.6138Z"
            stroke={color}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.9374 11.2941L4.97576 21.2558C4.5238 21.7077 3.79097 21.7077 3.33897 21.2558C2.88701 20.8038 2.88701 20.071 3.33897 19.619L13.3006 9.65732L14.5493 10.0454L14.9374 11.2941Z"
            stroke={color}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.5508 13.4894L21.5933 14.532"
            stroke={color}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.1318 14.8884V16.3628"
            stroke={color}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.70587 6.46313H8.23145"
            stroke={color}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.1051 4.04333L10.0625 3.00077"
            stroke={color}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default AiSparkleIcon
